import React, { useState, useEffect } from 'react';
import Icon from '../icons/Icon';

export default function PredictionPoll({ match }) {
  const matchId = match.id;
  const storageKey = `vf-prediction-${matchId}`;

  const [vote, setVote] = useState(null);
  const [results, setResults] = useState({ home: 0, draw: 0, away: 0 });

  // Seed deterministic-ish results from match id
  useEffect(() => {
    const saved = localStorage.getItem(storageKey);
    if (saved) setVote(saved);

    // Generate seeded results
    let seed = 0;
    for (let i = 0; i < matchId.length; i++) seed += matchId.charCodeAt(i);
    const rand = (n) => ((seed * (n + 1) * 9301 + 49297) % 233280) / 233280;
    const home = Math.floor(30 + rand(1) * 40);
    const draw = Math.floor(15 + rand(2) * 30);
    const away = 100 - home - draw;
    setResults({ home, draw, away: Math.max(5, away) });
  }, [matchId, storageKey]);

  const handleVote = (choice) => {
    if (vote) return;
    setVote(choice);
    localStorage.setItem(storageKey, choice);
    setResults(prev => {
      const next = { ...prev };
      next[choice] = Math.min(100, next[choice] + 2);
      return next;
    });
  };

  const home = match.teams.home;
  const away = match.teams.away;

  return (
    <div className="prediction-poll">
      <div className="poll-title">
        <Icon name="vote" size={18} /> Who will win?
      </div>
      <div className="poll-options">
        <button
          className={`poll-option ${vote === 'home' ? 'voted' : ''} ${vote ? 'disabled' : ''}`}
          onClick={() => handleVote('home')}
          disabled={!!vote}
        >
          <img src={home.logo} alt={home.name} />
          <span className="poll-team-name">{home.short}</span>
          {vote && <div className="poll-bar" style={{ width: `${results.home}%` }}></div>}
          {vote && <span className="poll-pct">{results.home}%</span>}
        </button>

        <button
          className={`poll-option draw ${vote === 'draw' ? 'voted' : ''} ${vote ? 'disabled' : ''}`}
          onClick={() => handleVote('draw')}
          disabled={!!vote}
        >
          <span className="draw-icon">=</span>
          <span className="poll-team-name">Draw</span>
          {vote && <div className="poll-bar" style={{ width: `${results.draw}%` }}></div>}
          {vote && <span className="poll-pct">{results.draw}%</span>}
        </button>

        <button
          className={`poll-option ${vote === 'away' ? 'voted' : ''} ${vote ? 'disabled' : ''}`}
          onClick={() => handleVote('away')}
          disabled={!!vote}
        >
          <img src={away.logo} alt={away.name} />
          <span className="poll-team-name">{away.short}</span>
          {vote && <div className="poll-bar" style={{ width: `${results.away}%` }}></div>}
          {vote && <span className="poll-pct">{results.away}%</span>}
        </button>
      </div>
      {vote && <div className="poll-thanks">Thanks for voting!</div>}
    </div>
  );
}
